// FullscreenSpinner.js
import React from 'react';
import '../App.css'; // or wherever you added the CSS

const FullscreenSpinner = () => {
  return (
    <div className="fullscreen-spinner-overlay">
      <div className="fullscreen-spinner"></div>
    </div>
  );
};

export default FullscreenSpinner;
